import React from 'react'

/**
 * The purpose of this component is to encapsulate common styling for
 * tables used on the site
 */

export default function DataTable({ children, ...rest }) {
  return (
    <table data-table="" {...rest}>
      {children}
    </table>
  )
}
